
import React from 'react';
import { Header } from '../layout/Header';
import ThankyouPage from '../../asset/ThankyouPage.webp'
import { useSearchParams } from 'react-router-dom';

export const ThankYou = () => {

  const [searchParams] = useSearchParams();
  const bookingType = searchParams.get('type')

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />

      {/* Main Thank You Section */}
      <section className="flex-1 relative">
        {/* Background Image - using coworking space image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${ThankyouPage})` }} >
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-center min-h-[calc(100vh-130px)] px-4 text-center">

          <div className="max-w-4xl mx-auto">
            <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-bold font-regrade leading-tight mb-8">
              You're Booked for   <br className="hidden md:block" />
              {bookingType === 'Affordability' ? 'a Tour at Offis Bay' : bookingType === 'freeday' ? 'Free Day Pass!'  : bookingType === 'virtual' ? 'Virtual Office'  : bookingType === 'meetingroom' ? 'Meeting Room'  : 'a Tour at Offis Bay'}
            </h1>

            <p className="text-white text-lg md:text-2xl lg:text-3xl font-base mb-8 md:mb-12 pt-4 md:pt-8">
              {bookingType === 'freeday' ? 'Thanks For Choosing Us.' : 'Thanks For Scheduling Your Visit.'}
            </p>

            <p className="text-white mt-8 md:mt-16 lg:mt-[10rem] text-base md:text-xl font-normal">
              Our Team Will Reach Out To Confirm Your Slot Shortly.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="items-stretch w-[100vw] flex flex-col overflow-hidden bg-white pt-2 pb-[21px] px-4 md:px-16">
        <div className="w-full text-sm text-[#1D1E1C] font-normal mt-[17px] max-md:max-w-full">
          <div className="flex w-full gap-[40px_100px] justify-between flex-wrap max-md:max-w-full">
            <div className="text-[#1D1E1C] leading-[25px]">
              © 2025 Offis Bay. All rights reserved.
            </div>
            <div className="text-[#1D1E1C] leading-[25px]">
              Designed and Developed by @Cruxcreations
            </div>
            <div className="flex min-w-60 gap-6 underline">
              <a href="/privacy" className="text-[#1D1E1C] hover:text-[#966376]">Privacy Policy</a>
              <a href="/terms" className="text-[#1D1E1C] hover:text-[#966376]">Terms of Service</a>
              <a href="/cookies" className="text-[#1D1E1C] hover:text-[#966376]">Cookies Settings</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
